export default {
      id: "blank-usage",
      viewBox: "0 0 194.5 283",
      url: __webpack_public_path__ + "img/icons.507a1d9d.svg#blank",
      toString: function () {
        return this.url;
      }
    }